import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

// Card 86akqxu0h: avisa o destaque da página inicial e o aviso ao entrar
// que um formulário foi respondido (sai da lista de pendentes).
export const SURVEYS_REFRESH_EVENT = "pitch:refresh-surveys";

export function dispatchSurveysRefresh() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SURVEYS_REFRESH_EVENT));
}

export function surveyApiFor(profile) {
  return profile === "partner" ? pitchPartnerApi : pitchCustomerApi;
}

export function surveyPath(profile, id) {
  return profile === "partner"
    ? `/connect/professor/formularios/${id}`
    : `/connect/aluno/formularios/${id}`;
}

// Formulários abertos que a pessoa recebeu e ainda não respondeu. Falha vira
// lista vazia: o destaque nunca pode atrapalhar a página inicial.
export async function loadPendingSurveys(profile) {
  try {
    const res = await surveyApiFor(profile).getPendingSurveys();
    return res.data?.data || [];
  } catch {
    return [];
  }
}
